const baseURL = 'https://aichat.mogul-tech.com'
// const baseURL = 'http://127.0.0.1:9900';

const headers = {
  token_remote: 'developer',
  authorization: 'Bearer xx'
}

let _instance = null
async function request (url, params, options) {
  if (options?.stream) {
    return tools.fetchStream(baseURL + url, params, { payload: { headers }, ...options })
  }
  if (!_instance) {
    _instance = new tools.Request({ baseURL })
    _instance.use('token', async (context, next) => {
      context.config.headers['token_remote'] = headers.token_remote
      context.config.headers['authorization'] = headers.authorization
      return next()
    })
  }
  return _instance.request(url, params, { json: true, ...options })
}

export default request
